<template>
  <div class="mx-4">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row">
        <div class="col-12 pb-0" style="display: flex; justify-content: center">
          <h4 class="margin-bottom: 0px;">Cambios</h4>
        </div>
        <div class="col-12 pt-0" style="display: flex; justify-content: flex-end">
          <v-btn color="primary" elevation="1" @click="Consultar">Consultar</v-btn>
        </div>
        <div class="col-12 mt-3">
          <v-card>
            <v-card-title style="display: flex; justify-content: flex-end">
              <v-col cols="12">
                <v-row style="display: flex; align-items: flex-end">
                  <v-col cols="4" class="pa-1">
                    <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                          class="pr-2 pb-1"
                        ></v-text-field>
                      </template>
                      <v-date-picker :title-date-format="titleDateFormat" v-model="begin" range locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialogBegin.save(begin)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.MU"
                      label="MU"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.idfirmarse_sistema"
                      label="Agente"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-autocomplete
                      hide-details
                      v-model="send.nomestatus"
                      :items="filter.nomestatus"
                      label="Estatus"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="8" class="pa-1">
                <v-btn elevation="2" @click="cleanFilter">Limpiar</v-btn>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
              </v-col>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              class="elevation-1"
              hide-default-footer
              loading-text="Cargando usuarios... Porfavor espere"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <div class="pa-1">
                  <button
                    v-on:click.prevent="Mostrar_Detalle_Solicitud(item.idsolicitudmodificarhorario)"
                    class="btn teleperformance-purpura2 view-details"
                  >
                    Ver detalle
                  </button>
                </div>
              </template>
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
            <PaginationFooter
              @sendItemsPerPage="getItemsPerPage"
              @lastClic="lastClic"
              @nextClic="nextClic"
              :page="page"
              :itemsLength="itemsLength"
            />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralMixin from "@/components/mixins/General";
import moment from "moment-timezone";
import PaginationFooter from "@/components/General/PaginationFooter";
import axios from "axios"; // Importar Axios en el componente

export default {
  mixins: [GeneralMixin],
  components: {
    PaginationFooter,
  },
  data() {
    return {
      url: process.env.VUE_APP_URL,
      loading: "",
      result: "d-none",
      retardos: [],
      headers: [
        { text: "Agente Propuesta", align: "left", value: "idfirmarse_sistema_propuesta" },
        { text: "MU", align: "start", value: "MU" },
        { text: "Fecha aceptación", align: "left", value: "fecha_aceptacion_oferta" },
        { text: "Hora Inicio", align: "left", value: "hora_inicio_evento" },
        { text: "Hora fin", align: "left", value: "hora_fin_evento" },
        { text: "Hora inicio propuesta", align: "center", value: "hora_inicio_evento_propuesta" },
        { text: "Hora fin propuesta", align: "center", value: "hora_fin_evento_propuesta" },
        { text: "Clave", align: "left", value: "idcambio" },
        { text: "Agente solicitante", align: "start", sortable: false, value: "idfirmarse_sistema" },
        { text: "Fecha solicitada", align: "left", value: "fecha_evento" },
        { text: "Estatus", align: "left", value: "nomestatus" },
      ],
      items: [],
      itemsBackup: [],
      filter: {
        nomestatus: [
          "Pendiente de Autorizar",
          "No Autorizado",
          "Autorizado",
          "En Proceso por Servidor",
          "Procesado por Servidor",
          "Error al procesar",
        ],
      },
      send: {
        MU: "",
        nomagente_sistema_propuesta: "",
        nomestatus: "",
        motivo: "",
      },
      begin: [],
      modalBegin: false,
      search: "",
      maxPages: 1000,
      data: {
        skip: 1,
        take: 10,
        filters: {
          fechas: this.begin,
        },
      },
      page: 1,
      itemsPerPage: 10,
      itemsLength: 0,
    };
  },
  methods: {
    getItemsPerPage(dato) {
      this.itemsPerPage = parseInt(dato);
      this.page = 1;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.MU ? this.send.MU : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    lastClic() {
      this.page--;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.MU ? this.send.MU : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    nextClic() {
      this.page++;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.MU ? this.send.MU : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    async Consultar() {
      this.Cargando();
      try {
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");
        if (this.begin.length < 2) {
          this.begin[1] = this.begin[0];
        }

        const url = this.url + "v2/api/admin/filter/intercambios";
        let data = (this.data = {
          skip: this.page,
          take: this.itemsPerPage,
          filters: {
            fechas: this.begin,
            mu: this.send.MU ? this.send.MU : undefined,
            agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
            status: this.send.nomestatus ? this.send.nomestatus : undefined,
          },
        });
        const {
          data: { data: items, count },
        } = await axios.post(url, { data });
        this.items = items.map((obj) => {
          return {
            ...obj,
            fecha_aceptacion_oferta: moment(obj.fecha_aceptacion_oferta).utc().format("DD-MM-YYYY HH:mm"),
          };
        });
        this.itemsLength = count;
        this.itemsBackup = this.items;

        if (items != null) {
          this.retardos = items;
        }
        if (this.retardos.length === 0) {
          swal("No hay intercambios", "Por el momento no hay solicitudes", "info");
        }
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
      }
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Listo() {
      var that = this;
      this.loading = "d-none";
      this.result = "";
      $(document).ready(function () {
        $("#result_table").DataTable({
          language: {
            sProcessing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            sZeroRecords: "No se encontraron resultados",
            sEmptyTable: "Ningún dato disponible en esta tabla",
            sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
            sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
            sInfoPostFix: "",
            sSearch: "Buscar:",
            sUrl: "",
            sInfoThousands: ",",
            sLoadingRecords: "Cargando...",
            oPaginate: {
              sFirst: "Primero",
              sLast: "Último",
              sNext: "Siguiente",
              sPrevious: "Anterior",
            },
            oAria: {
              sSortAscending: ": Activar para ordenar la columna de manera ascendente",
              sSortDescending: ": Activar para ordenar la columna de manera descendente",
            },
          },
          order: [],
        });
      });
      $("#accordionSidebar")
        .find(".nav-item")
        .each(function (key, element) {
          $(element).removeClass("active");
        });
      $("#Contratos_opcion").addClass("active");
    },
    Ver_Retardo(idretardo) {
      this.$router.push({ name: "Retardo", params: { idretardo: idretardo } });
    },
    cleanFilter() {
      for (let key in this.send) {
        this.send[key] = "";
      }
      this.Consultar();
    },
  },
  computed: {
    usuario() {
      return this.$store.getters.getUsuario;
    },
    dateRangeText() {
      return this.begin.join(" ~ ");
    },
    titleDateFormat() {
      // Aquí puedes incluir la clase personalizada en la cadena de formato de fecha
      return (date) => {
        return this.$vuetify.lang.t("Fechas seleccionadas");
      };
    },
  },
  created() {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    this.begin = [sevenDaysAgo.toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
    this.Consultar();
  },
};
</script>

<style scoped></style>
